import { FlexContainer, FlexItem } from '~/components/Grid'
import Card from './Card'
import { TypeTailoredSolutionsBlockSkeleton } from '~/types/contentful'
import { Entry } from 'contentful'
import { getContentfulAsset } from '~/libs/contentful/helpers'

type TailoredSolutionsProps = {
  section: Entry<TypeTailoredSolutionsBlockSkeleton, 'WITHOUT_UNRESOLVABLE_LINKS', string>
}

export const TailoredSolutions = ({ section }: TailoredSolutionsProps) => {
  const data = section.fields

  const firstCardImage = getContentfulAsset(data.firstCardImage)
  const secondCardImage = getContentfulAsset(data.secondCardImage)
  const thirdCardImage = getContentfulAsset(data.thirdCardImage)

  const bookmarks = [
    {
      id: 'land',
      title: data.firstCardTitle,
      link: data.firstCardLink,
      height: '312px',
      backgroundImage: firstCardImage?.fields,
      backgroundColor: '#f7f9fb',
      description: data.firstCardDescription,
    },
    {
      id: 'excel',
      title: data.secondCardTitle,
      link: data.secondCardLink,
      height: '398px',
      backgroundImage: secondCardImage?.fields,
      backgroundColor: '#9da6ff',
      description: data.secondCardDescription,
    },
    {
      id: 'stay',
      title: data.thirdCardTitle,
      link: data.thirdCardLink,
      height: '497px',
      backgroundImage: thirdCardImage?.fields,
      backgroundColor: ' #f4f6fa',
      description: data.thirdCardDescription,
    },
  ]

  return (
    <>
      <section
        data-block-id={data.blockId}
        className="max-md:p-[61px_20px_45px] my-25 -mx-8 max-xl:py-0 max-xl:px-11 max-xl:m-[100px_-32px_50px] max-lg:my-20 max-lg:-mx-7 max-md:m-[0_-18px_0]"
      >
        <FlexContainer
          justify="between"
          className="max-xl:flex-row max-xl:items-start max-md:flex-col max-md:gap-10 relative flex-col h-[640px] max-xl:h-auto max-xl:flex-nowrap max-xl:gap-14"
        >
          <FlexContainer
            className="relative justify-between flex-col max-xl:w-[40%] max-md:w-full"
            justify="between"
            withGap={true}
          >
            <FlexItem desktop={5} laptop={12}>
              <h2 className="text-xl max-md:text-l max-md:max-w-[280px]">{data.title}</h2>
            </FlexItem>
            <FlexItem desktop={4} laptop={12}>
              <p className="text-s">{data.description}</p>
            </FlexItem>
          </FlexContainer>
          <FlexContainer
            className="max-md:w-full max-xl:w-[54%]"
            justify={'between'}
            flexWrap={'nowrap'}
          >
            <FlexContainer
              justify="between"
              flexWrap="nowrap"
              style={{ bottom: 0, alignItems: 'end' }}
              className="absolute max-xl:static gap-8 max-xl:grid max-xl:grid-cols-1 max-xl:mt-0 max-xl:gap-4"
            >
              {bookmarks.map((bookmark) => (
                <Card key={bookmark.id} bookmark={bookmark} blockId={data.blockId as string} />
              ))}
            </FlexContainer>
          </FlexContainer>
        </FlexContainer>
      </section>
    </>
  )
}
